@let ticket = data.ticket | toTicketTile: data.productDefinition.name;
<aw-dialog
  class="max-h-[80vh] w-full bg-white sm:w-[700px]"
  (onClose)="dialogRef.close()"
  [content]="editTicketOptionsDialogContent"
  [footer]="footerContent"
  [data]="data"
  [title]="
    (ticket.name || data.name) +
    ' ' +
    (textStore.texts()
      | filterTexts: ERelationType.edit : EEntityType.generic
      | language)
  "
  [width]="width">
  <ng-template #editTicketOptionsDialogContent>
    <aw-ticket-options-form
      [positionInCart]="data.index"
      [productDefinition]="data.productDefinition"
      [productForm]="productForm"
      [tariffProductGroup]="
        productForm.value.tariffGroup!
      "></aw-ticket-options-form>
  </ng-template>
  <ng-template #footerContent>
    <div class="flex w-full flex-row items-center justify-between pt-4">
      <aw-button
        type="button"
        [style]="'primary-alt'"
        id="ticket-remove-from-cart-dialog-cancel"
        (click)="dialogRef.close()"
        (keydown.enter)="dialogRef.close()"
        >{{
          textStore.texts()
            | filterTexts: ERelationType.cancel : EEntityType.generic
            | language
        }}</aw-button
      >
      <aw-button
        type="button"
        id="ticket-remove-from-cart-dialog-submit"
        [disabledText]="
          textStore.texts()
            | filterTexts: ERelationType.saveDisabled : EEntityType.generic
            | language
        "
        [isDisabled]="!productForm.valid"
        (click)="saveChanges()"
        (keydown.enter)="saveChanges()"
        >{{
          textStore.texts()
            | filterTexts: ERelationType.save : EEntityType.generic
            | language
        }}</aw-button
      >
    </div>
  </ng-template>
</aw-dialog>
